exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".week-column /deep/ .ivu-table-cell {\n  padding-left: 2px;\n  padding-right: 2px;\n}\n.ivu-table-fixed {\n  margin-bottom: 10px !important;\n  height: auto !important;\n}\n", ""]);

// exports
